
<div class="container-fluid" *ngIf="!assignorInfo">
</div>
<div class="container-fluid" *ngIf="assignorInfo">
    <div class="row">
        <div class="col-lg-6 col-md-6 col-sm-12 py-2">
            <div class="custom-input-container">
                <p id="lblCnpj" class="custom-p-label">CNPJ</p>
                <p id="cnpj" class="custom-p-input">{{ assignorInfo.document.toString() | cnpj}}</p>
            </div>
        </div>
        <div class="col-lg-6 col-md-6 col-sm-12 py-2">
            <div class="custom-input-container">
                <p id="lblDataAbertura" class="custom-p-label">Data de abertura</p>
                <p id="dataAbertura" class="custom-p-input">{{assignorInfo.openingDate | date}}
                    <app-kyc-status class="float-right" *ngIf="openingDateStatus" [validation]="openingDateStatus" [statusId]="openingDateStatus.statusId"></app-kyc-status>
                </p>
            </div>
        </div>
    </div>
    <div class="row">
        <div class="col-lg-6 col-md-6 col-sm-12 py-2">
            <div class="custom-input-container">
                <p id="lblRazaoSocial" class="custom-p-label">Razão Social</p>
                <p id="razaoSocial" class="custom-p-input">{{assignorInfo.companyName}}</p>
            </div>
        </div>
        <div class="col-lg-6 col-md-6 col-sm-12 py-2">
            <div class="custom-input-container">
                <p id="lblNomeFantasia" class="custom-p-label">Nome fantasia</p>
                <p id="nomeFantasia" class="custom-p-input">{{assignorInfo.tradeName}}</p>
            </div>
        </div>
    </div>
    <div class="row">
        <div class="col-lg-6 col-md-6 col-sm-12 py-2">
            <div class="custom-input-container">
                <p id="lblInscricaoEstadual" class="custom-p-label">Inscricão estadual</p>
                <p id="inscricaoEstadual" class="custom-p-input">{{assignorInfo.stateRegistration}}</p>
            </div>
        </div>
        <div class="col-lg-6 col-md-6 col-sm-12 py-2">
            <div class="custom-input-container">
                <p id="lblInscricaoMunicipal" class="custom-p-label">Inscrição municipal</p>
                <p id="inscricaoMunicipal" class="custom-p-input">{{assignorInfo.municipalRegistration}}</p>
            </div>
        </div>
    </div>
    <div class="row">
        <div class="col-lg-6 col-md-6 col-sm-12 py-2">
            <div class="custom-input-container">
                <p id="lbltelefone" class="custom-p-label">Email</p>
                <p id="email" class="custom-p-input">{{ assignorInfo.email }}
                    <app-kyc-status class="float-right" *ngIf="emailStatus" [validation]="emailStatus" [statusId]="emailStatus.statusId"></app-kyc-status>
                </p>
            </div>
        </div>

        <div class="col-lg-6 col-md-6 col-sm-12 py-2">
            <div class="custom-input-container">
                <p id="lbltelefone" class="custom-p-label">Telefone</p>
                <p id="telefone" class="custom-p-input">{{ normalize(assignorInfo.phone.toString()) }}
                    <app-kyc-status class="float-right" *ngIf="phoneStatus" [validation]="phoneStatus" [statusId]="phoneStatus.statusId"></app-kyc-status>
                </p>
            </div>
        </div>
    </div>
</div>
